import { render, staticRenderFns } from "./QuestionQuizViewV1.vue?vue&type=template&id=ed0871c4&scoped=true"
import script from "./QuestionQuizViewV1.vue?vue&type=script&lang=js"
export * from "./QuestionQuizViewV1.vue?vue&type=script&lang=js"
import style0 from "./QuestionQuizViewV1.vue?vue&type=style&index=0&id=ed0871c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0871c4",
  null
  
)

export default component.exports